import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notice"]
  static values = { text: String }

  connect() {
    this.noticeTarget.addEventListener("animationend", this.#finished)
  }

  disconnect() {
    this.noticeTarget.removeEventListener("animationend", this.#finished)
  }

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => this.#showCopied())
  }

  #showCopied() {
    const notice = this.noticeTarget
    notice.classList.remove("is-on")
    notice.textContent = ""
    void notice.offsetWidth
    notice.textContent = "Copied"
    notice.classList.add("is-on")
  }

  #finished = (event) => {
    if (event.target !== this.noticeTarget) return
    if (!String(event.animationName).startsWith("clipboard-copied")) return
    this.noticeTarget.classList.remove("is-on")
    this.noticeTarget.textContent = ""
  }
}
